export const searchParams = new URLSearchParams(window.location.search);
export const orgId = searchParams?.get("account");
export const website = searchParams?.get("sitename");
